import { post, postAuth, handleResponse } from "./base.service";
import { CONTROLLER, ACTION } from "../utilities/api.constants";

export const authenticate = (
  data
) => {
  return post(CONTROLLER.LOGIN + ACTION.AUTHENTICATE, data).then(
    handleResponse
  );
};

export const controlCandidate = (data) => {
  return post(CONTROLLER.LOGIN + ACTION.CONTROL_CANDIDATE, data).then(
    handleResponse
  );
};

export const reSendCandidateCode = (data) => {
  return post(CONTROLLER.LOGIN + ACTION.RESEND_CANDIDATE_CODE, data).then(
    handleResponse
  );
};

export const authenticateCandidate = (data) => {
  return post(CONTROLLER.LOGIN + ACTION.AUTHENTICATE_CANDIDATE, data).then(
    handleResponse
  );
};

export const forgotPassword = (data) => {
  return post(CONTROLLER.LOGIN + ACTION.FORGOT_PASSWORD, data).then(
    handleResponse
  );
};

export const resetPasswordWithSms = (data) => {
  return post(CONTROLLER.LOGIN + ACTION.RESET_PASSWORD_WITH_SMS, data).then(
    handleResponse
  );
};

export const sendSmsForgotPasswordWithOTP = (data) => {
  return post(
    CONTROLLER.LOGIN + ACTION.SENDSMS_FORGOTPASSWORD_WITHOTP,
    data
  ).then(handleResponse);
};

export const resetPassword = (oldPassword, newPassword) => {
  var data = {
    oldPassword,
    newPassword,
  };
  return postAuth(CONTROLLER.LOGIN + ACTION.RESET_PASSWORD, data).then(
    handleResponse
  );
};

export const addLead = (
  data
) => {
  return post(CONTROLLER.LOYALTY + ACTION.ADD_LEAD, data).then(
    handleResponse
  );
};

export const authenticateOtpService = (
  data
) => {
  return post(CONTROLLER.LOGIN + ACTION.AUTHENTICATE_OTP, data).then(
    handleResponse
  );
};

export const authenticateVerifyService = (
  data
) => {
  return post(CONTROLLER.LOGIN + ACTION.AUTHENTICATE_VERIFY, data).then(
    handleResponse
  );
};

